import { Property } from "../types/booking";

export const getPropertyName = (
  propertyId: string,
  properties: Property[]
): string => {
  const property = properties.find((p) => p.id == propertyId);
  return property?.name || "Unknown Property";
};
